const dbBodyColors = [
    { key: 'oceanMist', value: 'Ocean Mist (AliceBlue)', color: 'AliceBlue' },
    { key: 'sunlight', value: 'Sunlight (LemonChiffon)', color: 'LemonChiffon' },
    { key: 'mint', value: 'Mint (Honeydew)', color: 'Honeydew' },
    { key: 'cloud', value: 'Cloud (GhostWhite)', color: 'GhostWhite' },
];

export default dbBodyColors;